<div class="exam-input-container" [formGroup]="examDateTimeRegionForm">
   <app-alert *ngIf="hasError" [state]="'error'">{{errorMsg}}</app-alert>
   <app-alert *ngIf="submissionError" [state]="'error'">{{submissionError}}</app-alert>
   <h1 id="on-demand-exams-at-h" tabindex="-1" i18n>Select date and time</h1>

   <app-time-zone-selection [timeZoneId]="existingInformation.timeZoneId" (calenderStartDate)="setCalenderStartDate($event)" formControlName="timeZoneSelection"></app-time-zone-selection>
   <app-date-selection [date]="existingInformation.examDateTime" [calenderStartDate]="calenderStartDate" formControlName="dateSelection"></app-date-selection>
   <app-time-selection [time]="existingInformation.time" formControlName="timeSelection"></app-time-selection>
</div>
